/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

/**
 * Enum pour les Urls
 * @readonly
 * @enum { string }  PathsNamesEnums
 */
export enum PathsNamesEnums {
  /** @type {string} */
  SUPERVISION$ = 'supervision',
  DASHBOARD$ = 'tableau-de-board',
  SYSTEM$ = 'systemes',
  INCIDENTS$ = 'incidents',
  CAMERA$ = 'camera',
  INHIBITIONS$ = 'inhibitions',
  ADMINISTRATION$ = 'administration',
  TMDLAPI$ = 'tmd_lapi',
  TMDLAPIINCIDENTS$ = 'incidents_tmd',
  TMDLAPIEXPLORER$ = 'explorer_tmd_lapi',
  TMDLAPICAMERAS$ = 'cameras_tmd_lapi',

  SIMULATOR$ = 'simulateur',
  TUNNELWATCH$ = 'tunnelwatch',
  DISPLAY$ = 'display',
  EXPLORE$ = 'explorer',
  VERSIONNING$ = 'versionning',
  USERS$ = 'utilisateurs',
  STATISTICS$ = 'statistiques',
  CHANGEDPASSWORD = '/tunnelwatch/changement-de-mot-de-passe',
  TUNNELWATCH = '/tunnelwatch',
  TUNNELWATCHONECAMERA = '/tunnelwatch/fiche-incident/:incident',
  TUNNELWATCHINCIDENTFILE = '/tunnelwatch/fiche-incident/',
  DASHBOARD = '/supervision/tableau-de-board/accueil',
  DISPLAY = '/supervision/display/accueil',
  CAMERAHOME = '/supervision/camera/accueil',
  CAMERASETTINGS = '/supervision/camera/parametres/:id',
  CAMERASEGMENTATION = '/supervision/camera/segmentation/:section',
  ONECAMERASEGMENTATION = '/supervision/camera/one/sequence/:section/:cameraId',
  ONECAMERASEGMENTATIONSEQUENCE = '/supervision/camera/one/sequence/',
  CITILOGINCIDENT = '/explorer/tools/incidenthistory',
  CAMERASETTINGID = '/supervision/camera/parametres/',
  CAMERACREATED = '/supervision/camera/creation',
  INCIDENTS = '/supervision/incidents/accueil',
  EXTRACTOR = '/tunnelwatch/extracteur/accueil',
  INHIBITIONS = '/supervision/inhibitions/accueil',
  SYSTEMSHOME = '/supervision/systemes/accueil',
  SYSTEMSCONFIG = '/supervision/systemes/section/',
  STATISTICS = '/supervision/camera/statistiques/:id',
  STATISTIC = '/supervision/camera/statistiques',
  SYSTEMSCONFIGID = '/supervision/systemes/section/:section',
  ADMINISTRATION = '/administration/accueil',
  VERSIONNING = '/administration/versionning',
  USERS = '/administration/utilisateurs',
  EXPLORE = '/explorer/accueil',
  SIMULATOR = '/supervision/simulateur/accueil',
  TMDLAPIINCIDENTS = '/tmd_lapi/incidents_tmd',
  TMDLAPIEXPLORER = '/tmd_lapi/explorer_tmd_lapi',
  TMDLAPICAMERAS = '/tmd_lapi/cameras_tmd_lapi',
  LOGIN = '/',
  FOGETPASSWORD = '/mot-de-passe-oublie',
  RESETPASSWORD = '/reinitialise-mot-de-passe/:reset',
  E404 = '*',

}


// WEBPACK FOOTER //
// ./src/apps/tunnel/enums/pathsnames/index.ts